import { SigningStatus } from "@models/annual-statements/annual-statement-enums";
import { DocumentRecord } from "@models/annual-statements/document-record";

export function checkIsDocumentRecordInSigning(documentRecords: (DocumentRecord)[]): boolean {
  const isInSigningStatuses = [
    SigningStatus.Sent,
    SigningStatus.Rejected,
    SigningStatus.Signed
  ];

  return documentRecords.some((documentRecord) => documentRecord.signingStatus != undefined && isInSigningStatuses.includes(documentRecord.signingStatus));
}
